module.exports = __webpack_public_path__ + "img/16.acabf7ff.svg";